import ReactQuill from 'react-quill';

import 'react-quill/dist/quill.snow.css';

type StrongRichTextProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

const DEFAULT_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, 4, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['clean'],
  ],
};

const DEFAULT_FORMATS = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'list',
  'bullet',
  'indent',
];

const StrongRichText = ({
  value,
  onChange,
  placeholder,
}: StrongRichTextProps) => {
  return (
    <ReactQuill
      theme='snow'
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      modules={DEFAULT_MODULES}
      formats={DEFAULT_FORMATS}
    />
  );
};

export default StrongRichText;
